"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerDto = exports.CustomerNoteDto = exports.AddCustomerNotesDto = exports.FindCustomersByOrganizationIdFiltersDto = exports.ByOrganizationIdCustomerIdDto = exports.ImportRentalsFromCSV = exports.ImportDashCustomerDto = exports.ImportProgramsFileDto = exports.ImportCustomerFromCSV = exports.ImportProductsFromDB = exports.FindByMembershipIdDto = void 0;
const organization_dto_1 = require("../organization/dto/organization.dto");
const general_dto_1 = require("./general.dto");
class FindByMembershipIdDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.FindByMembershipIdDto = FindByMembershipIdDto;
class ImportProductsFromDB {
}
exports.ImportProductsFromDB = ImportProductsFromDB;
class ImportCustomerFromCSV {
}
exports.ImportCustomerFromCSV = ImportCustomerFromCSV;
class ImportProgramsFileDto extends ImportCustomerFromCSV {
}
exports.ImportProgramsFileDto = ImportProgramsFileDto;
class ImportDashCustomerDto extends ImportCustomerFromCSV {
}
exports.ImportDashCustomerDto = ImportDashCustomerDto;
class ImportRentalsFromCSV extends ImportCustomerFromCSV {
}
exports.ImportRentalsFromCSV = ImportRentalsFromCSV;
class ByOrganizationIdCustomerIdDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByOrganizationIdCustomerIdDto = ByOrganizationIdCustomerIdDto;
class FindCustomersByOrganizationIdFiltersDto extends general_dto_1.PaginationQuery {
}
exports.FindCustomersByOrganizationIdFiltersDto = FindCustomersByOrganizationIdFiltersDto;
class AddCustomerNotesDto {
}
exports.AddCustomerNotesDto = AddCustomerNotesDto;
class CustomerNoteDto {
}
exports.CustomerNoteDto = CustomerNoteDto;
class CustomerDto {
}
exports.CustomerDto = CustomerDto;
//# sourceMappingURL=customer.dto.js.map